module.exports = __webpack_public_path__ + "static/media/Template_30.f03129b2.png";